import { render, staticRenderFns } from "./DiscoveryExpertPublicView.vue?vue&type=template&id=4847627c&scoped=true"
import script from "./DiscoveryExpertPublicView.vue?vue&type=script&lang=js"
export * from "./DiscoveryExpertPublicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847627c",
  null
  
)

export default component.exports